import { SectionCard } from "./SectionCard";

type Props = {
  isBulkImporting: boolean;
  hasEditorName: boolean;
  bulkImportText: string;
  allowPolicyOverwrite: boolean;
  onAllowPolicyOverwriteChange: (value: boolean) => void;
  onLoadStarterCompanyDocs: () => void;
  onBulkImportTextChange: (value: string) => void;
  onBulkImport: () => void;
  onClearBulkImportText: () => void;
};

export function KbBulkImportSection(props: Props) {
  return (
    <SectionCard title="Bulk import" description="Paste JSON or load a file to batch-create early documentation. The same save rules apply here, so trainer access imports org-scoped draft proposals only.">
      <div className="space-y-3">
        <div className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-600 dark:border-zinc-700 dark:bg-zinc-900/40 dark:text-zinc-300">
          Accepted formats: an array of article objects, or an object with an articles array. Each item needs a title plus content/body, or chunk text that can be merged into an article body.
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className="rounded-lg border border-indigo-300 bg-indigo-50 px-3 py-2 text-sm font-medium text-indigo-700 hover:bg-indigo-100 dark:border-indigo-700 dark:bg-indigo-950/45 dark:text-indigo-200 dark:hover:bg-indigo-900/50"
            onClick={props.onLoadStarterCompanyDocs}
            disabled={props.isBulkImporting}
          >
            Load starter company docs
          </button>
          <div className="self-center text-xs text-gray-500 dark:text-zinc-400">
            Uses the built-in company-doc seed pack as a starting point for KB population.
          </div>
        </div>
        <textarea
          className="h-48 w-full rounded-lg border border-gray-300 px-3 py-2 font-mono text-xs dark:border-zinc-600 dark:bg-zinc-900/60 dark:text-zinc-200"
          value={props.bulkImportText}
          onChange={(event) => props.onBulkImportTextChange(event.target.value)}
          placeholder={'[{"title":"Delivery policy overview","content":"...","scope":"org","doc_type":"process","status":"draft"}]'}
        />
        <label className="flex items-start gap-2 text-xs text-gray-700 dark:text-zinc-300">
          <input
            type="checkbox"
            className="mt-0.5 rounded border-gray-300"
            checked={props.allowPolicyOverwrite}
            onChange={(e) => props.onAllowPolicyOverwriteChange(e.target.checked)}
            disabled={props.isBulkImporting}
          />
          <span>
            Allow overwriting existing <strong>policy</strong> articles in this batch (skips per-item confirmation; use only when you intend to replace policy docs).
          </span>
        </label>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className="rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white disabled:opacity-50"
            onClick={props.onBulkImport}
            disabled={props.isBulkImporting || !props.hasEditorName}
          >
            {props.isBulkImporting ? "Importing…" : "Run import"}
          </button>
          <button
            type="button"
            className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200"
            onClick={props.onClearBulkImportText}
            disabled={!props.bulkImportText || props.isBulkImporting}
          >
            Clear import text
          </button>
        </div>
      </div>
    </SectionCard>
  );
}